<script lang="ts">
  import { getContext } from 'svelte';
  import { Link } from '@squareup/public-web-design-system';
  import { DesignSystem as DesignSystemEnum } from '$lib/helpers/design-system';
  import type { LinkComponentAnchorProps } from './types';

  type $$Props = LinkComponentAnchorProps;

  export let url: $$Props['url']; // #payment
  export let scrollOffset: $$Props['scrollOffset'];
  export let text: $$Props['text'];
  export let textExceptLastWord: $$Props['textExceptLastWord'] = undefined;
  export let textLastWord: $$Props['textLastWord'] = undefined;
  export let locale: $$Props['locale'];
  export let isActive: $$Props['isActive'] = undefined;

  const designSystem = getContext<DesignSystemEnum>('designSystem');

  const linkClickHandler = (event: Event) => {
    event.preventDefault();

    const selector = url;
    window.history.pushState({ page: selector }, `page: ${selector}`, selector);

    const selectorElem: HTMLElement | null = document.querySelector(selector);
    if (selectorElem) {
      const newTop =
        selectorElem.getBoundingClientRect().top - document.body.getBoundingClientRect().top - scrollOffset;

      window.scrollTo({
        behavior: 'smooth',
        top: newTop,
      });

      if (selectorElem.hasAttribute('tabindex')) {
        selectorElem.focus({ preventScroll: true });
      } else {
        selectorElem.setAttribute('tabindex', '-1');
        selectorElem.focus({ preventScroll: true });
        selectorElem.removeAttribute('tabindex');
      }
    }
  };
</script>

{#if designSystem === DesignSystemEnum.PublicWebDesignSystem}
  <Link variant="anchor" href={url} onClick={(e) => linkClickHandler(e)} {text} {isActive} />
{:else}
  <a class="LinkComponent--anchor" href={url} on:click={linkClickHandler}>
    {#if locale === 'ja-JP'}
      <span>{text}</span>
    {:else}
      {#if textExceptLastWord}
        {textExceptLastWord}
      {/if}
      <span>{textLastWord}</span>
    {/if}
  </a>
{/if}

<style lang="scss">
  @layer standard-components {
    .LinkComponent--anchor {
      span {
        white-space: nowrap;

        &::after {
          content: '→';
          display: inline-block;
          position: relative;
          top: 1px;
          margin-left: 0.25em;
          line-height: initial;
          transition: transform var(--duration-quick) var(--easing-sharp);
          transform: rotate(90deg);
        }
      }
    }
  }
</style>
